export default __webpack_public_path__ + "static/media/pic-6.dd9125e0.jpg";